import {
  findAirlineLogoFromAdmin,
  findAirlineNameFromAdmin,
} from "../../../utils/airlineLogoFromAdmin";

/**
 * Presentation identity for a review / summary flight header.
 * Catalog name and logo win. A missing catalog name keeps the existing label,
 * or the IATA code when that label is only the code.
 */
export function resolveReviewAirlineIdentity({ airlines, code, fallbackName }) {
  const normalizedCode = String(code || "").trim();
  const catalogName = findAirlineNameFromAdmin(airlines, normalizedCode);
  const logoSrc = findAirlineLogoFromAdmin(airlines, normalizedCode);
  const fallback = String(fallbackName || "").trim();
  const fallbackIsCode =
    Boolean(normalizedCode) &&
    fallback.toUpperCase() === normalizedCode.toUpperCase();
  const name =
    catalogName ||
    (fallback && !fallbackIsCode ? fallback : "") ||
    normalizedCode ||
    fallback;

  return {
    code: normalizedCode.toUpperCase(),
    name,
    logoSrc,
  };
}

export function labelIsAirlineCode(label, code) {
  const text = String(label || "").trim();
  const normalized = String(code || "").trim();
  if (!text || !normalized) return false;
  return text.toUpperCase() === normalized.toUpperCase();
}
